import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const BackButton = ({ className = "" }) => {
  const navigate = useNavigate();

  return (
    <motion.button
      type="button"
      whileHover={{ x: -4, scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      onClick={() => navigate(-1)}
      className={`inline-flex items-center gap-2 rounded-full border border-white/60 bg-white/70 px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm backdrop-blur-xl transition hover:border-orange-200 hover:text-orange-600 ${className}`}
    >
      <ArrowLeft className="h-4 w-4" />
      Back
    </motion.button>
  );
};

export default BackButton;
